/**
 * Singles mode utilities.
 * In "Simples" game mode, each athlete competes individually.
 * Implementation: each player gets an auto-created "virtual team" with their name.
 * The rest of the system (standings, brackets, matches) works with teams as usual,
 * but the UI shows player names instead of team names.
 */

/**
 * Check if a championship is in singles mode.
 */
export function isSinglesMode(championship: { game_mode?: string | null } | null | undefined): boolean {
  return (championship as any)?.game_mode === "Simples";
}

/**
 * For singles mode, returns the display name (which is the team name = player name).
 * For team mode, returns the team name as-is.
 */
export function getCompetitorName(
  team: { name: string; short_name?: string | null } | null | undefined,
  singlesMode: boolean
): string {
  if (!team) return "—";
  return team.name;
}

/**
 * Get the short display name for a competitor.
 */
export function getCompetitorShortName(
  team: { name: string; short_name?: string | null } | null | undefined,
  singlesMode: boolean
): string {
  if (!team) return "—";
  if (singlesMode) {
    // For singles, use first name or abbreviation
    const parts = team.name.split(" ");
    if (parts.length === 1) return team.name.substring(0, 3).toUpperCase();
    return (parts[0][0] + ". " + parts[parts.length - 1]).substring(0, 10);
  }
  return team.short_name || team.name.substring(0, 3).toUpperCase();
}
